import moment from 'moment';
import React, { Component } from 'react';
import { Table as BootstrapTable, Col, Row } from 'react-bootstrap';

import { IS_VALID } from 'utils';

export default class View extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingRelation: false,
			cardType: [],
			excludedCardType: [],
			specificUser: [],
			blacklistedUser: [],
		};

		this.getRelation = this.getRelation.bind(this);
	}

	getRelation() {
		let {
			selectedData,

			getRelation,
		} = this.props;

		if (IS_VALID(selectedData)) {
			this.setState({ isLoadingRelation: true });

			getRelation()
				.then(([cardType, excludedCardType, specificUser, blacklistedUser]) => {
					let cardTypeArray = cardType.map((item) => item.get('name'));

					let excludedCardTypeArray = excludedCardType.map((item) => item.get('name'));

					let specificUserArray = specificUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					let blacklistedUserArray = blacklistedUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					this.setState({
						isLoadingRelation: false,
						cardType: cardTypeArray,
						excludedCardType: excludedCardTypeArray,
						specificUser: specificUserArray,
						blacklistedUser: blacklistedUserArray,
					});
				})
				.catch((err) => {
					console.log('getRelation error');
					console.log(err);

					this.setState({ isLoadingRelation: false });
				});
		}
	}

	render() {
		let { isLoadingRelation, cardType, excludedCardType, specificUser, blacklistedUser } =
			this.state;

		let { selectedData } = this.props;

		const GET_VALUE = (key) => {
			if (IS_VALID(selectedData) && IS_VALID(selectedData.get(key))) {
				let value = '';

				if (key === 'createdAt' || key === 'updatedAt') {
					value = moment(selectedData.get(key)).format('MMM-DD-YYYY');
				} else if (key === 'createdBy' || key === 'updatedBy') {
					if (IS_VALID(selectedData.get(key))) {
						value = selectedData.get(key).get('name') || '';
					}
				} else if (key === 'icon') {
					value = (
						<div
							style={{
								maxWidth: '200px',
								maxHeight: '200px',
								height: '200px',
								width: '200px',
								display: 'table-cell',
								verticalAlign: 'middle',
							}}
						>
							<img src={selectedData.get(key).url()} width="100%" />
						</div>
					);
				} else if (key === 'browser') {
					value =
						selectedData.get(key).charAt(0).toUpperCase() +
						selectedData.get(key).slice(1).toLowerCase();
				} else if (
					key === 'new' ||
					key === 'isUseGoogleChrome' ||
					key === 'isEpicMillions'
				) {
					value = selectedData.get(key).toString();
				} else {
					value = selectedData.get(key);
				}

				return value;
			} else {
				return '';
			}
		};

		return (
			<BootstrapTable bordered responsive>
				<tbody>
					<tr>
						<td>
							<b>Icon</b>
						</td>
						<td>
							<p>{GET_VALUE('icon')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Name</b>
						</td>
						<td>{GET_VALUE('name')}</td>
					</tr>
					<tr>
						<td>
							<b>Label</b>
						</td>
						<td>
							<p>{GET_VALUE('label')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Browser</b>
						</td>
						<td>
							<p>{GET_VALUE('browser')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Use Google Chrome</b>
						</td>
						<td>
							<p>{GET_VALUE('isUseGoogleChrome')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>URL</b>
						</td>
						<td>
							<p>{GET_VALUE('url')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Epic Millions</b>
						</td>
						<td>
							<p>{GET_VALUE('isEpicMillions')}</p>
						</td>
					</tr>
					{/* <tr>
                        <td>
                        <b>Position</b>
                        </td>
                        <td>
                            <p>{GET_VALUE("position")}</p>
                        </td>
                    </tr> */}
					<tr>
						<td>
							<b>Sort</b>
						</td>
						<td>
							<p>{GET_VALUE('sort')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>New</b>
						</td>
						<td>
							<p>{GET_VALUE('new')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Card Type</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								cardType.join(', ')
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Excluded Card Type</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								excludedCardType.join(', ')
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Device Type</b>
						</td>
						<td>
							<p>{GET_VALUE('deviceType')}</p>
						</td>
					</tr>
					<tr>
						<td>
							<b>Specific User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								specificUser.join(', ')
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Excluded User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								blacklistedUser.join(', ')
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Created At</b>
						</td>
						<td>{GET_VALUE('createdAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated At</b>
						</td>
						<td>{GET_VALUE('updatedAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Created By</b>
						</td>
						<td>{GET_VALUE('createdBy')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated By</b>
						</td>
						<td>{GET_VALUE('updatedBy')}</td>
					</tr>
				</tbody>
			</BootstrapTable>
		);
	}

	componentDidMount() {
		this.getRelation();
	}
}



// WEBPACK FOOTER //
// ./components/AppMenu/FormContainer/View.js